import { StorefrontFeedItem } from '@/ux/pages/StoreFrontPage/Social/StoreFrontSocial';
import { StoreEvent, StoreFront } from '@/ux/pages/StoreFrontPage/StoreFront';

import { createStateWithType } from '../context-utils';
import { STORE_USER_ROLE, StorefrontType } from './StorefrontType';

export const storefrontProductsSelector = createStateWithType<StorefrontType, StoreEvent[]>(
  (state: StorefrontType) => {
    return state.products;
  },
);

export const storefrontFeedsSelector = createStateWithType<StorefrontType, StorefrontFeedItem[]>(
  (state: StorefrontType) => {
    return state.feeds;
  },
);

export const storefrontStoreSelector = createStateWithType<StorefrontType, StoreFront>(
  (state: StorefrontType) => {
    return state.store;
  },
);

export const storefrontHighlightsSelector = createStateWithType<StorefrontType, any[]>(
  (state: StorefrontType) => {
    return state.highlights;
  },
);

export const storefrontSocialScrollDistance = createStateWithType<StorefrontType, number>(
  (state: StorefrontType) => {
    return state.socialScrollDistance;
  },
);

export const storefrontUserRoleSelector = createStateWithType<StorefrontType, STORE_USER_ROLE>(
  (state: StorefrontType) => {
    return state.userRole;
  },
);
